/**
 * The email login code: how long it is (Better Auth's `otpLength` reads this, so the field's
 * slots always match what is sent) and how the code field reads what someone types or pastes.
 * Pure, so the Worker, the pages and the browser bundle share it.
 */
export const LOGIN_CODE_LENGTH = 6;

/**
 * The code in whatever was typed or pasted: its digits, in order, up to the code's length.
 * Spaces, dashes, a trailing newline and any other character are dropped, so "123 456",
 * "123-456" and "123456\n" all give "123456"; NFKC first turns full-width digits into ASCII.
 */
export function codeFrom(raw: string): string {
  return raw.normalize("NFKC").replace(/\D/g, "").slice(0, LOGIN_CODE_LENGTH);
}
